<template>
  <div class="user-page">
    <!-- Header: Account Title -->
    <div class="page-header">
       <span class="header-icon"><van-icon name="manager-o" /></span>
       <span class="header-title">账号</span>
    </div>

    <!-- Anonymous ID Row -->
    <div class="id-row">
       <span class="label">用户号:</span>
       <span class="value">{{ anonymousId }}</span>
       <span class="copy-tag" @click="copyText(anonymousId)">复制</span>
    </div>

    <!-- Main Card -->
    <div class="main-card">
       <div class="card-content">
          <div class="avatar-col">
             <img src="https://img.yzcdn.cn/vant/cat.jpeg" class="avatar-img" />
          </div>
          <div class="info-col">
             <!-- Logged In State -->
             <div v-if="isLoggedIn">
                <div class="username-row">
                   {{ user.username }} 
                   <span class="copy-tag-sm" @click="copyText(user.username)">复制</span>
                </div>
                <div class="member-row">会员: <span class="orange-text">{{ user.memberDate }}</span></div>
                <div class="coin-row">金币: <span class="orange-text">{{ user.coins }}</span></div>
             </div>
             <!-- Unlogged State -->
             <div v-else>
                <div class="username-row">未登录</div>
                <div class="member-row">会员: <span class="orange-text">非会员</span></div>
                <div class="coin-row">金币: <span class="orange-text">0</span></div>
             </div>
          </div>
       </div>

       <!-- Action Button -->
       <div class="action-btn-row">
          <button v-if="isLoggedIn" class="btn-logout" @click="logout">退出</button>
          <button v-else class="btn-login" @click="showLogin = true">登录/注册</button>
       </div>

       <!-- Warning for Unlogged -->
       <div v-if="!isLoggedIn" class="warning-box">
          <div class="warn-title">温馨提示:</div>
          <div class="warn-text pink-text">为防止账号丢失</div>
          <div class="warn-text pink-text">请绑定手机号</div>
       </div>
    </div>

    <!-- Login Modal -->
    <div v-if="showLogin" class="modal-mask">
       <div class="modal-box">
          <div class="modal-close" @click="showLogin = false"><van-icon name="cross" /></div>
          <div class="modal-title">绑定手机号 防丢失会员</div>
          <div class="modal-subtitle">注册/登录</div>
          
          <div class="form-group">
             <div class="input-label">手机号</div>
             <input type="tel" v-model="loginForm.phone" class="dark-input" />
          </div>
          <div class="form-group">
             <div class="input-label">密码</div>
             <input type="password" v-model="loginForm.password" class="dark-input" />
          </div>
          
          <button class="btn-submit" @click="handleLogin">注册/登录</button>
       </div>
    </div>

    <!-- Bottom Nav (Custom Style) -->
    <div class="bottom-nav">
      <div class="nav-item" @click="$router.push('/home').catch(()=>{})">
        <div class="nav-btn btn-dark">首页</div>
      </div>
      <div class="nav-item" @click="$router.push('/purchased')">
        <div class="nav-btn btn-yellow">已购买</div>
      </div>
      <div class="nav-item">
        <div class="nav-btn btn-yellow">账号</div>
      </div>
      <div class="nav-item" @click="toggleBookmark">
        <div class="nav-btn btn-dark">收藏本站</div>
      </div>
    </div>
    
    <!-- Re-use Bookmark Modal from Home if needed, or simple redirect -->
  </div>
</template>

<script>
export default {
  name: 'User',
  data() {
    return {
      anonymousId: '',
      isLoggedIn: false,
      showLogin: false,
      user: {
        username: '',
        memberDate: '',
        coins: 0
      },
      loginForm: {
        phone: '',
        password: ''
      }
    }
  },
  created() {
    this.initUser();
  },
  methods: {
    initUser() {
        // 1. Anonymous ID
        let anon = localStorage.getItem('anonymousId');
        if (!anon) {
            anon = Math.random().toString(16).substr(2, 8);
            localStorage.setItem('anonymousId', anon);
        }
        this.anonymousId = anon;

        // 2. Login Token
        const token = localStorage.getItem('token');
        const userStr = localStorage.getItem('user');
        if (token && userStr) {
            this.isLoggedIn = true;
            this.user = JSON.parse(userStr);
        } else {
            this.isLoggedIn = false;
        }
    },
    copyText(text) {
        const input = document.createElement('input');
        input.setAttribute('value', text);
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        document.body.removeChild(input);
        this.$toast('复制成功');
    },
    async handleLogin() {
        if (!this.loginForm.phone || !this.loginForm.password) {
            this.$toast('请输入账号密码');
            return;
        }
        try {
            const { data } = await this.$http.post('/login', {
                username: this.loginForm.phone,
                password: this.loginForm.password
            });
            
            if (data.success) {
                this.isLoggedIn = true;
                this.user = {
                    username: this.loginForm.phone,
                    memberDate: '2026-02-09', // Mock date for now
                    coins: data.coins || 0
                };
                localStorage.setItem('token', 'mock_token_' + Date.now());
                localStorage.setItem('user', JSON.stringify(this.user));
                this.showLogin = false;
                this.$toast.success('登录成功');
            } else {
                this.$toast.fail('登录失败: ' + data.message);
            }
        } catch (e) {
            this.$toast.fail('网络错误');
        }
    },
    logout() {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        this.isLoggedIn = false;
        this.user = {};
        this.$toast('已退出');
    },
    toggleBookmark() {
        this.$router.push({ name: 'Home', params: { showBookmark: true }}); // Simplified logic
        alert('请前往首页使用收藏功能'); 
    }
  }
}
</script>

<style scoped>
.user-page {
    background-color: #111;
    min-height: 100vh;
    color: #fff;
    font-family: sans-serif;
    padding-bottom: 60px;
}
.page-header {
    padding: 15px;
    font-size: 18px;
    font-weight: bold;
    display: flex;
    align-items: center;
    color: #ddd;
}
.header-icon { margin-right: 5px; color: #ffaa00; font-size: 20px;}

.id-row {
    background-color: #000;
    padding: 10px 15px;
    font-size: 16px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #222;
}
.id-row .label { color: #aaa; margin-right: 10px; }
.id-row .value { color: #ffaa00; font-weight: bold; font-size: 20px; margin-right: 10px;}
.copy-tag {
    background-color: #0000ff;
    color: white;
    font-size: 12px;
    padding: 2px 8px;
    border-radius: 10px;
    cursor: pointer;
}

.main-card {
    padding: 20px;
}
.card-content {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
}
.avatar-img {
    width: 70px;
    height: 70px;
    border-radius: 50%;
    border: 2px solid #333;
}
.info-col {
    margin-left: 15px;
}
.username-row {
    font-size: 20px;
    font-weight: bold;
    color: #fff;
    margin-bottom: 5px;
    display: flex;
    align-items: center;
    gap: 5px;
}
.copy-tag-sm {
    background-color: #0000ff;
    color: white;
    font-size: 12px;
    padding: 1px 6px;
    border-radius: 8px;
}
.member-row, .coin-row {
    font-size: 14px;
    color: #ccc;
    line-height: 1.5;
}
.orange-text { color: #ffaa00; }

.action-btn-row {
    margin-top: 20px;
}
.btn-login {
    width: 100%;
    background-color: #ffaa00;
    color: #000;
    border: none;
    padding: 10px;
    font-size: 16px;
    font-weight: bold;
    border-radius: 5px;
}
.btn-logout {
    width: 100%;
    background-color: #333;
    color: #fff;
    border: none;
    padding: 10px;
    font-size: 16px;
    border-radius: 5px;
}

.warning-box {
    margin-top: 20px;
}
.warn-title { color: #fff; font-size: 16px; font-weight: bold; margin-bottom: 5px;}
.warn-text { font-size: 24px; line-height: 1.3;}
.pink-text { color: #ff00ff; }

/* Modal */
.modal-mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 200;
}
.modal-box {
    width: 80%;
    background: #111;
    border: 1px solid #333;
    padding: 20px;
    border-radius: 5px;
    position: relative;
    text-align: center;
}
.modal-close {
    position: absolute;
    right: 10px;
    top: 10px;
    color: #fff;
    font-size: 20px;
}
.modal-title {
    color: #ffaa00;
    font-weight: bold;
    margin-bottom: 20px;
    background: #222;
    padding: 10px;
    border-radius: 2px;
}
.modal-subtitle {
    color: #ffaa00;
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 15px;
}
.form-group {
    margin-bottom: 15px;
    text-align: left;
}
.input-label { color: #fff; margin-bottom: 5px;}
.dark-input {
    width: 100%;
    background: #222;
    border: 1px solid #444;
    color: #fff;
    padding: 10px;
    box-sizing: border-box;
    border-radius: 4px;
}
.btn-submit {
    width: 100%;
    background: #ffaa00;
    color: #000;
    border: none;
    padding: 12px;
    font-size: 16px;
    font-weight: bold;
    border-radius: 4px;
    margin-top: 10px;
}

/* Bottom Nav */
.bottom-nav {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: #111;
    display: flex;
    padding: 5px 0;
    border-top: 1px solid #333;
    z-index: 100;
}
.nav-item {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
}
.nav-btn {
    width: 80%;
    text-align: center;
    padding: 8px 0;
    font-size: 14px;
    border-radius: 4px;
    font-weight: bold;
}
.btn-dark {
    background-color: #222;
    color: white;
    border: 1px solid #444;
}
.btn-yellow {
    background-color: #ffaa00;
    color: black;
}
</style>
